/**
 * Единая точка чтения переменных окружения.
 * Всё, что начинается с VITE_, попадает в бандл — секретов здесь быть не должно.
 */
const toBool = (value: string | undefined, fallback: boolean): boolean =>
  value === undefined || value === '' ? fallback : value === 'true'

export const env = {
  /** Базовый URL API. Пустая строка = тот же origin. */
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  /** Включить авторизацию (страница входа, защищённые маршруты). */
  authEnabled: toBool(import.meta.env.VITE_AUTH_ENABLED, false),
  /** hash-роутер нужен там, где нет своего сервера, отдающего index.html на любой путь. */
  routerMode: (import.meta.env.VITE_ROUTER === 'hash' ? 'hash' : 'browser') as 'hash' | 'browser',
  appVersion: __APP_VERSION__,
} as const
